import React, { } from "react";
import { Container, Card, } from "react-bootstrap";

import Assurance from "./Assurance/Assurance";
import AttendantService from "./Attendant_Service/Attendant_Service";
import FAQ from "./FAQ/FAQ";
import Header from "./Header";
import { useNavigate } from "react-router-dom";


function Home(props) {
    let navigate = useNavigate();

    return (
        <React.Fragment>
            
            <Container fluid style={{ padding: "0px" }}>
                <Card style={{ border: "none" }}>
                    <Card.Body style={{ padding: "0px", }} >
                        <Header></Header>
                        {/* {window.innerWidth < 700 && <div className="text-center" >
                            <div style={window.innerWidth > 700 ? { padding: "0px" } : { position: "fixed", bottom: "0px", zIndex: 99999, padding: "0px", minWidth: "100vw" }}>
                                <button onClick={() => {
                                    navigate('booking');
                                }} className="p-2 mt-2" style={{ fontSize: "19px", fontWeight: "400px", width: window.innerWidth > 700 ? "395" : window.innerWidth, border: "none", color: "white", backgroundColor: "#2b7dbd" }}>
                                    Book Home Trial @ ₹299
                                </button>
                            </div>
                        </div>} */}




                        <Card style={{ border: "none" }}>
                            <div>
                                <AttendantService></AttendantService>
                                <Assurance></Assurance>
                                <FAQ></FAQ>
                            </div>
                        </Card>
                    </Card.Body>
                </Card>
            </Container>
            <button onClick={() => {
                navigate('booking');
            }} className={'trialBtnHome'}>
                Book Home Trial @ ₹299
            </button>
        </React.Fragment >
    );
}

export default Home